import { createSlice } from "@reduxjs/toolkit";

const sessionExpiredSlice = createSlice({
  name: "sessionExpired",
  initialState: {
    showModal: false,
  },
  reducers: {
    showSessionExpiredModal: (state) => {
      state.showModal = true;
    },
    hideSessionExpiredModal: (state) => {
      state.showModal = false;
    },
  },
});

export const { showSessionExpiredModal, hideSessionExpiredModal } =
  sessionExpiredSlice.actions;

export default sessionExpiredSlice.reducer;

